import { render, staticRenderFns } from "./AppSingleItemAnswer.vue?vue&type=template&id=b1a59e70&scoped=true"
import script from "./AppSingleItemAnswer.vue?vue&type=script&lang=ts"
export * from "./AppSingleItemAnswer.vue?vue&type=script&lang=ts"
import style0 from "./AppSingleItemAnswer.vue?vue&type=style&index=0&id=b1a59e70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a59e70",
  null
  
)

export default component.exports